<template>
  <div>
    <el-container>
      <el-main>
        <div style="margin-bottom: 16px">
          <el-input v-model="tableQuery.name" @change="selectUser" style="width: 160px;"
                    placeholder="工号、姓名、电话"></el-input>
          <el-cascader
              :options="deptTree" v-model="tableQuery.deptArray"
              :props="{ multiple: true, checkStrictly: true ,value: 'id',label: 'name',children: 'children'}"
              clearable collapse-tags style="margin-left: 10px;width: 260px" placeholder="请选择部门" filterable></el-cascader>
          <el-select
                     v-model="tableQuery.jobList"
              multiple filterable
              collapse-tags clearable
              style="margin-left: 10px;width: 200px;"
              placeholder="请选择岗位">
            <el-option v-for="item in coachPosition" :key="item.dictValue" :label="item.dictLabel"
                       :value="item.dictValue"/>
          </el-select>
          <el-button type="danger" style="margin: 0 10px" @click="selectUser">搜 索</el-button>
        </div>
        <el-table border ref="table" class="table" row-key="id"
                  :data="tableData" height="606px" :cell-style="{padding:0+'px'}" v-loading="tableQuery.loading"
                  :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
          <el-table-column width="120" property="workId" label="工号"></el-table-column>
          <el-table-column width="170" property="coachName" label="姓名">
            <template #default="coach">
              <div style="display: flex; align-items: center;">
                <!-- 图片容器：增加相对定位，作为性别图标的定位基准 -->
                <div style="position: relative; margin: 10px 10px 2px 0;">
                  <el-image
                      style="width: 35px; height: 35px; border-radius: 6px;"
                      :src="coach.row.portrait"
                      :preview-src-list="[coach.row.portrait]"
                  >
                    <div slot="error" class="image-slot" style="display: flex; justify-content: center;">
                      <span class="el-icon-picture-outline" style="margin-top: 10px"></span>
                    </div>
                  </el-image>
                  <!-- 性别图标：绝对定位到图片右上角 -->
                  <div v-if="coach.row.sex === 0" style="color: #F56C6C;" class="el-icon-female sex"></div>
                  <div v-if="coach.row.sex === 1" style="color: #409EFF;" class="el-icon-male sex"></div>
                </div>
                <div>
                  {{ coach.row.coachName | truncate }}
                  <span v-if="coach.row.children?.length>1" @click="handleRowClick(coach.row)"
                        class="el-icon-arrow-down" style="margin-left: 10px"></span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="140" property="personagePhone" label="电话">
            <template #default="coach">
              <el-tooltip class="box-item" effect="dark" placement="top">
                <div slot="content">
                  <div v-if="coach.row.coachCount>1">
                    <span>{{ coach.row.personagePhone + ' - 个人' }}</span> <br/>
                  </div>
                  <div>
                    <div v-if="coach.row.coachCount === 1">
                      <span>{{ coach.row.personagePhone + ' - 个人' }}</span> <br/>
                      <span>{{ +coach.row.coachPhone + ' - 工作' }}</span>
                    </div>
                  </div>
                  <div v-if="coach.row.coachCount === null">
                    <span>{{ +coach.row.coachPhone + ' - 工作' }}</span>
                  </div>
                </div>
                <div>{{ coach.row.personagePhone | truncate(11) }}
                  <span v-if="coach.row.children?.length>1" @click="handleRowClick(coach.row)"
                        class="el-icon-arrow-down" style="margin-left: 10px"></span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column width="160" show-overflow-tooltip label="生日">
            <template #header>
              <div style="cursor: pointer;display: flex;align-items: center" v-popover:popover>
                生日
                <svg-icon
                    icon-class="filter"
                    style="font-size: 19px; margin-left: 4px"
                    :style="{ color: tableQuery.birthday > 0 ? '#ff4d4f' : '' }"/>
              </div>
              <el-popover ref="popover" placement="top-start" width="80" trigger="hover">
                <div>
                11
                </div>
              </el-popover>
            </template>
            <template #default="coach">
              <el-tooltip class="box-item" effect="dark"
                          :content="coach.row.birthday+' ~ '+(coach.row.birthdayType == 0 ? '阴历':'阳历')+' 距离生日还有'+coach.row.birthdayCount+'天'"
                          placement="top">
                <div style="display: flex">
                  <div>{{ coach.row.birthday }}</div>
                  <div style="margin: -6px 0 0 6px;font-size: 8px;">
                    <div style="transform: scale(0.9);color: #67C23A;font-weight: bold"
                         v-if="coach.row.birthdayCount == 0">今天
                    </div>
                    <div style="transform: scale(0.9);color: #409EFF;font-weight: bold"
                         v-if="coach.row.birthdayCount == 1">明天
                    </div>
                    <div style="color: #409EFF;font-weight: bold"
                         v-if="coach.row.birthdayCount >1 && coach.row.birthdayCount <=7">{{ coach.row.birthdayCount }}
                    </div>
                    <div v-if="coach.row.birthdayCount > 7">{{ coach.row.birthdayCount }}</div>
                  </div>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column width="180" label="部门">
            <template #default="coach">
              <el-tooltip class="box-item" effect="dark" :content="coach.row.deptName || ''" placement="top">
                <div v-if="coach.row.deptName === null" style="color:#A8ABB2">
                  未分配部门 ！
                  <div v-if="coach.row.children?.length>1" class="el-icon-arrow-down" style="margin-left: 10px"></div>
                </div>
                <div v-else>
                  {{ coach.row.deptName | truncate(8) }}
                  <span v-if="coach.row.children?.length>1" @click="handleRowClick(coach.row)"
                        class="el-icon-arrow-down" style="margin-left: 10px"></span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column width="180" label="校区">
            <template #default="coach">
              <el-tooltip class="box-item" effect="dark" :content="coach.row.campusName || ''" placement="top">
                <div v-if="coach.row.campusName === null" style="color:#A8ABB2">
                  未分配校区 ！
                  <div v-if="coach.row.children?.length>1" class="el-icon-arrow-down" style="margin-left: 10px"></div>
                </div>
                <div v-else>
                  {{ coach.row.campusName | truncate(8) }}
                  <span v-if="coach.row.children?.length>1" @click="handleRowClick(coach.row)"
                        class="el-icon-arrow-down" style="margin-left: 10px"></span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column width="190" property="workId" label="岗位">
            <template #default="coach">
              <div style="display: flex;align-items: center">
                <el-select size="small"
                           v-model="coach.row.positionId"
                           placeholder="未分配岗位 !"
                           style="width: 160px">
                  <el-option v-for="item in coachPosition" :key="item.dictValue" :label="item.dictLabel"
                             :value="item.dictValue" disabled/>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="190" property="workId" label="角色">
            <template #default="coach">
              <div style="display: flex;align-items: center">
                <el-select size="small"
                           v-model="coach.row.roleList"
                           multiple
                           collapse-tags
                           collapse-tags-tooltip
                           placeholder="未分配角色 !"
                           style="width: 160px">
                  <el-option v-for="item in coach.row.roleList" :key="item.id" :label="item.roleName" :value="item.id"
                             disabled/>
                </el-select>
                <span v-if="coach.row.children?.length>1" @click="handleRowClick(coach.row)" class="el-icon-arrow-down"
                      style="margin-left: 10px"></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="140" property="entryTime" label="入职时间"></el-table-column>
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template #default="scope">
              <div>
                <el-button type="danger" @click="toDetail(scope.row)" slot="reference" size="mini">详 情</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right;margin: 20px 10px"
                       :page-sizes="[100, 200, 300, 400]"
                       :page-size="tableQuery.pageSize"
                       @current-change="changePage"
                       layout="total, prev, pager, next, jumper"
                       :total="tableQuery.total">
        </el-pagination>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import birthdayUtils from '@/utils/birthday';
import {selectUser} from '/src/api/contacts/user'
import {getDictByKey} from "../../../../api/contacts/dict";
import '/src/assets/styles.css';

export default {
  name: "User",
  data() {
    return {
      deptTree:[],
      coachPosition: [],
      valueStrictly: null,
      tableQuery: {
        name: "",
        deptArray:[],
        birthday: null,
        deptList: [],
        total: 0,
        pageIndex: 1,
        pageSize: 10,
        loading: false,
        jobList: [],
        roleList:[]
      },
      tableData: []
    };
  },
  created() {
    this.selectUser();
    getDictByKey("station").then(val => {
      if (val.status) {
        this.coachPosition = val.data;
      }
    })
    this.deptTree = JSON.parse(localStorage.getItem("deptTree"));
  },
  methods: {
    getPositionLabel(positionId) {
      // 若 positionId 为空，返回“未选择岗位”
      if (!positionId) return '未选择岗位';
      // 从 coachPosition 中查找对应项
      const position = this.coachPosition.find(item => item.dictValue == positionId);
      // 有匹配项返回 dictLabel，无则返回“未知岗位”
      return position ? position.dictLabel : '未知岗位';
    },
    handleRowClick(row) {
      // 1. 判断当前行是否为父级（有children或hasChildren为true）
      const isParent = row.children && row.children.length > 0;
      if (!isParent) return;
      // 2. 获取表格实例，调用展开/折叠API（关键步骤）
      this.$refs.table.toggleRowExpansion(row); // 切换展开状态（展开→折叠，折叠→展开）
    },
    toDetail(row) {
      this.tableData.forEach(item => {
        item.identityId = item.id;
        if (item.id === row.id) {
          this.$router.push({
            path: "/admin/contacts/userDetails",
            query: {
              item: JSON.stringify(item)
            }
          });
        }
      })
    },
    /**
     * 选择分页
     */
    changePage(res) {
      this.tableQuery.pageIndex = res;
      this.selectUser();
    },
    selectUser() {
      this.tableQuery.deptList = [];
      this.tableQuery.deptArray.forEach(item=>{
        this.tableQuery.deptList.push(item[item.length-1])
      })
      this.tableQuery.loading = true;
      selectUser(this.tableQuery).then(val => {
        this.tableQuery.loading = false;
        if (val.status) {
          val.data.records.forEach(item => {
            if (item && item.birthday != null && item.birthdayType != null) {
              let day = birthdayUtils.getDaysUntilBirthday(item.birthday, item.birthdayType);
              item.birthdayCount = day;
              item.positionId = item.positionId + '';
            }
            if (item.children) {
              item.children.forEach(son => {
                son.positionId = son.positionId + ''
              })
            }
          })
          this.tableData = val.data.records;
          this.tableQuery.total = val.data.total;
        }
      })
    },
  }
}
</script>

<style scoped>
/** 路由缩放动画会导致 el-select高度回不去，这里写死高度 **/
::v-deep .el-input__inner {
  height: 40px !important;
}
/deep/ .el-tabs__active-bar {
  background-color: #ff4d4f;
}
::v-deep .el-select__tags {
  max-width: 160px !important;
}
/**悬浮 */
::v-deep .el-tabs__item:hover {
  color: #ff4d4f;
  cursor: pointer;
  opacity: 1;
}
::v-deep .el-select__tags-text{
 max-width: 60px;
}

.table {
  width: 100%;
  border-radius: 10px;
  padding: 6px 10px 10px 0px;
  height: 550px;
}

.el-aside {
  text-align: center;
  padding: 10px 20px;
  margin: 8px 20px 0 0;
  border-radius: 10px;
  box-shadow: 0 0px 20px 0 rgba(94, 93, 93, 0.1)
}

.sex {
  position: absolute;
  right: -10px;
  top: -6px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  padding: 1px;
  font-weight: bold;
}
/* 确保折叠后的标签容器不被强制换行 */
::v-deep .el-select__tags {
  flex-wrap: nowrap !important; /* 强制不换行 */
  white-space: nowrap;/* 防止文本折行 */
  padding-right: 16px;
}
::v-deep .el-cascader__tags {
  flex-wrap: nowrap !important; /* 强制不换行 */
  white-space: nowrap;/* 防止文本折行 */
  padding-right: 120px;
}
/* 原有样式保持不变，新增以下代码 */
/* 匹配所有层级的子级行（level-1 及以上），设置背景色 #F5F7FA */
::v-deep .el-table__body tr.el-table__row--level-1,
::v-deep .el-table__body tr.el-table__row--level-2,
::v-deep .el-table__body tr.el-table__row--level-3 {
  background-color: #F5F7FA !important;
}

/* 优化子级行 hover 效果（可选，避免 hover 时覆盖背景色） */
::v-deep .el-table__body tr.el-table__row--level-1:hover > td,
::v-deep .el-table__body tr.el-table__row--level-2:hover > td,
::v-deep .el-table__body tr.el-table__row--level-3:hover > td {
  background-color: #F5F7FA !important; /* hover 时稍深的颜色，保持视觉一致性 */
}
</style>